import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private isLoading: boolean = false;
    private isFinalizing: boolean = false;

    show(): void {
        this.isLoading = true;
        this.loadGif();
    }

    hide(): void {
        this.isLoading = false;
        this.loadGif();
    }

    loadGif() {
        if (JSON.parse(localStorage.getItem('isLoggedin')) === true) {
            return false;
        } else {
            return true;
        }
    }

    getLoadingState(): boolean {
        return this.isLoading;
    }

    showFinalize(): void {
        this.isFinalizing = true;
        this.loadGif();
    }

    hideFinalize(): void {
        this.isFinalizing = false;
        this.loadGif();
    }

    getFinalizeState(): boolean {
        return this.isFinalizing;
    }
}
